
import Layout from "../../components/layout/Layout";
import Faq from "../../components/faq/Faq";
import { useFgts } from "./hook/useFgts";
import { AboutFgts } from "./AboutFgts";
import { Advantages } from "./AdvantagesFgts";
import { HowAnticipate } from "./HowAnticipateFgts";
import { WhoCanHireFgts } from "./WhoCanHireFgts";

export default function Fgts() {

    const { maxWithdraw, getSubHeader, faqs, calculateFgts, onGoToRegister, onGoTo } = useFgts();

    return (
        <Layout
            subHeader={getSubHeader()}
        >
            <AboutFgts onGoToRegister={onGoToRegister} maxWithdraw={maxWithdraw} calculateFgts={calculateFgts} />
            <Advantages onGoToRegister={onGoToRegister} />
            <HowAnticipate onGoToRegister={onGoToRegister} />
            <WhoCanHireFgts onGoToRegister={onGoToRegister} onGoTo={onGoTo} />
            <Faq
                title='Tire suas dúvidas sobre a antecipação do Saque-Aniversário FGTS Bmg'
                faqs={faqs}
            />
        </Layout>
    );
}
